(() => {
  "use strict";
  var t = {
      d: (e, i) => {
        for (var r in i)
          t.o(i, r) &&
            !t.o(e, r) &&
            Object.defineProperty(e, r, { enumerable: !0, get: i[r] });
      },
      o: (t, e) => Object.prototype.hasOwnProperty.call(t, e),
      r: (t) => {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(t, "__esModule", { value: !0 });
      },
    },
    e = {};
  t.r(e), t.d(e, { TreatmentFinder: () => TreatmentFinder });
  class TreatmentFinder extends HTMLElement {
    constructor() {
      super(), (this.typeFilters = []);
    }
    buildCollectionUrl(t) {
      if ("#" === t || !this.typeFilters.length) return t;
      return `${t}?${this.typeFilters
        .map((t) => `filter_type=${t.type}`)
        .join("&")}`;
    }
    formatFilterText(t) {
      if (t.length <= 2) return t.map((t) => t.filter).join(", ");
      return `${t
        .slice(0, 2)
        .map((t) => t.filter)
        .join(", ")} +${t.length - 2} more`;
    }
    updateButtonState(t, e, i) {
      t.setAttribute("href", e),
        (t.innerText = t.getAttribute(
          i ? "data-disabled-text" : "data-active-text"
        )),
        t.classList.toggle("treatment-finder__btn--disabled", i);
    }
    resetForm() {
      (this.typeFilters = []),
        this.querySelectorAll(".gbl-styled-checkbox__input").forEach((t) => {
          t.checked = !1;
        }),
        this.querySelectorAll(".gbl-image-thumb-checkbox__input").forEach(
          (t) => {
            t.checked = !1;
          }
        );
    }
    connectedCallback() {
      (this.filterButtons = this.querySelectorAll(".dropdown-button")),
        (this.filterSections = this.querySelectorAll(
          ".treatment-finder__content-item"
        ));
      const initializeState = () => {
        this.typeFilters = [];
        const t = this.filterButtons[0],
          e = this.filterButtons[1],
          i = this.querySelector(".treatment-finder__btn"),
          r = this.querySelector(".gbl-image-thumb-checkbox__input:checked");
        if (r) {
          const s = r.value,
            l = r.getAttribute("data-collection");
          if (
            (t && (t.querySelector("span").innerText = s),
            this.updateButtonState(i, l, !1),
            this.querySelectorAll(
              ".gbl-styled-checkbox__input:checked"
            ).forEach((t) => {
              const e = t.value,
                i = t.getAttribute("data-label");
              this.typeFilters.push({ type: e, filter: i });
            }),
            this.typeFilters.length > 0 && e)
          ) {
            e.querySelector("span").innerText = this.formatFilterText(
              this.typeFilters
            );
            const t = this.buildCollectionUrl(l);
            i.setAttribute("href", t);
          } else
            e &&
              (e.querySelector("span").innerText =
                e.getAttribute("data-placeholder"));
        } else
          t &&
            (t.querySelector("span").innerText =
              t.getAttribute("data-placeholder")),
            this.updateButtonState(i, "#", !0),
            e &&
              (e.querySelector("span").innerText =
                e.getAttribute("data-placeholder"));
      };
      if (this.hasAttribute("data-reset-form")) {
        const t = this.querySelector(".treatment-finder__btn");
        t.addEventListener("click", (e) => {
          "#" !== t.getAttribute("href") &&
            window.addEventListener(
              "pagehide",
              () => {
                this.resetForm();
              },
              { once: !0 }
            );
        });
      } else
        setTimeout(() => {
          initializeState();
        }, 100),
          window.addEventListener("popstate", () => {
            (this.typeFilters = []), initializeState();
          });
      this.filterButtons.forEach((t, e) => {
        t.addEventListener("click", () => {
          let i = !1;
          this.classList.contains("treatment-finder--open-by-default") ||
            (t.classList.contains("active") &&
              ((i = !0),
              this.filterSections[e].parentNode.classList.add("hidden"))),
            this.filterSections.forEach((t) => {
              t.classList.add("hidden");
            }),
            this.filterButtons.forEach((t) => {
              t.classList.remove("active");
            }),
            i ||
              (this.filterSections[e].parentNode.classList.remove("hidden"),
              t.classList.add("active"),
              this.filterSections[e].classList.remove("hidden"));
        });
      }),
        this.querySelectorAll(".gbl-image-thumb-checkbox__input").forEach(
          (t) => {
            t.addEventListener("click", () => {
              this.querySelectorAll(".gbl-image-thumb-checkbox__input").forEach(
                (e) => {
                  e !== t && (e.checked = !1);
                }
              );
              const e = t.value,
                i = t.getAttribute("data-collection"),
                r = this.querySelector(".treatment-finder__btn");
              if (t.checked) {
                let t = i;
                if (this.typeFilters.length > 0) {
                  t = `${i}?${this.typeFilters
                    .map((t) => `filter_type=${t.type}`)
                    .join("&")}`;
                }
                this.updateButtonState(r, t, !1),
                  this.filterButtons.forEach((t) => {
                    t.classList.contains("active") &&
                      (t.querySelector("span").innerText = e);
                  });
              } else
                this.updateButtonState(r, "#", !0),
                  this.filterButtons.forEach((t) => {
                    t.classList.contains("active") &&
                      (t.querySelector("span").innerText =
                        t.getAttribute("data-placeholder"));
                  });
            });
          }
        ),
        this.querySelectorAll(".gbl-styled-checkbox__input").forEach((t) => {
          t.addEventListener("click", () => {
            const e = t.value,
              i = t.getAttribute("data-label"),
              r = this.filterButtons[1],
              s = this.querySelector(".treatment-finder__btn");
            if (
              (t.checked
                ? this.typeFilters.push({ type: e, filter: i })
                : (this.typeFilters = this.typeFilters.filter(
                    (t) => t.type !== e
                  )),
              this.typeFilters.length > 0)
            ) {
              r.querySelector("span").innerText = this.formatFilterText(
                this.typeFilters
              );
              const t = s.getAttribute("href");
              if (t && "#" !== t) {
                const e = t.split("?")[0],
                  i = this.buildCollectionUrl(e);
                s.setAttribute("href", i);
              }
            } else {
              r.querySelector("span").innerText =
                r.getAttribute("data-placeholder");
              const t = s.getAttribute("href");
              t && "#" !== t && s.setAttribute("href", t.split("?")[0]);
            }
          });
        });
    }
  }
  customElements.get("treatment-finder") ||
    customElements.define("treatment-finder", TreatmentFinder);
  var i = self;
  for (var r in e) i[r] = e[r];
  e.__esModule && Object.defineProperty(i, "__esModule", { value: !0 });
})();
